module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture27-8aa921e5329f715349a84fa3cbf8e6b3.jpg";